module.exports = __webpack_public_path__ + "assets/img/siding-3.0621ce82.jpg";